/* import __COLOCATED_TEMPLATE__ from './reached-list.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';

export default class ReachedList extends Component {
  get titleComponent() {
    return 'stats-system/list/tooltip-group/header/reached-title';
  }
}
